function getScrollbarWidth() {
	return window.innerWidth - document.documentElement.clientWidth
}

function createScrollbarWidthCssVariable() {
	document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px')
}

createScrollbarWidthCssVariable()
